import Kanban from "@/components/shared/Kanban";
import api from "@/lib/api";

const STAGES = ["Nouveau", "Contacté", "Démonstration", "Offre envoyée", "Abonné", "Perdu"];

export default function CentralCRM() {
  return (
    <Kanban
      title="CRM commercial"
      subtitle="Pipeline des prospects Vision POS"
      stages={STAGES}
      testid="central-crm"
      fetchList={() => api.get("/central/prospects").then((r) => r.data)}
      createItem={(body) => api.post("/central/prospects", body)}
      moveStage={(id, stage) => api.patch(`/central/prospects/${id}/stage`, { stage })}
    />
  );
}
